module.exports = __webpack_public_path__ + "static/media/hair-photo-1-2-x.b0926c99.jpg";